import isMobile from 'ismobilejs'

export const isMobileOrTablet = () => {
  const userAgent = window.navigator.userAgent

  return isMobile(userAgent).phone || isMobile(userAgent).tablet
}
